"use strict";

define('view/submission/submission.approvals.tab',['require','exports','module','backbone','marionette','uikit/uikit','model/base','model/person','libs/format/date','templates','../../langs'],function (require, exports, module) {
  'use strict';

  var Backbone = require('backbone'),
    Mn = require('marionette'),
    UIKit = require('uikit/uikit'),
    BaseModel = require('model/base'),
    PersonModel = require('model/person'),
    DateFormatter = require('libs/format/date'),
    Templates = require('templates'),
    langs = require('../../langs'),
    ADMIN_CERTIFY = 'ADMIN_CERTIFY';
  function InvestigatorResponseFormatter(value, task) {
    if (task.get('response') === ADMIN_CERTIFY) {
      return 'Administratively Certified';
    } else if (task.get('taskEndDate')) {
      return 'Certified';
    } else if (task.get('taskEndedBy')) {
      return 'Completed by ' + task.get('taskEndedBy').get('displayName');
    } else {
      return 'Pending Certification';
    }
  }
  function OrgApproverResponseFormatter(value, task) {
    if (task.get('taskEndDate')) {
      if (task.get('people').length == 1) {
        return 'Completed';
      } else {
        return 'Completed by ' + task.get('taskEndedBy').get('displayName');
      }
    } else {
      return 'Pending Certification';
    }
  }
  var INVESTIGATOR_APPROVALS_COLUMNS = [{
    text: 'Name',
    data: 'person.displayName'
  }, {
    text: 'Role',
    data: 'assignment'
  }, {
    text: 'Result',
    data: 'response',
    formatter: InvestigatorResponseFormatter
  }, {
    text: 'Date',
    data: 'taskEndDate',
    formatter: DateFormatter('L LT')
  }];
  var ORG_APPROVALS_COLUMNS = [{
    text: 'Name',
    data: 'displayName'
  }, {
    text: 'Organization',
    data: 'organizationName'
  }, {
    text: 'Result',
    data: 'result',
    formatter: OrgApproverResponseFormatter
  }, {
    text: 'Date',
    data: 'taskEndDate',
    formatter: DateFormatter('L LT')
  }];
  function setupApprovers(data) {
    var approver = null,
      approverMap = {},
      results = null,
      adminCertify = null;
    for (var i = 0, len = data.length; i < len; i++) {
      approver = data[i];
      if (approver.response === ADMIN_CERTIFY) {
        adminCertify = approver.activitiTaskId;
        approverMap[approver.activitiTaskId] = {
          taskEndedBy: approver.person,
          taskEndedByDate: approver.taskEndDate
        };
      }
    }
    if (adminCertify) {
      results = approverMap[adminCertify];
      for (var i = 0, len = data.length; i < len; i++) {
        approver = data[i];
        if (results && approver.response !== ADMIN_CERTIFY) {
          approver.taskEndedBy = results.taskEndedBy;
          approver.taskEndedByDate = results.taskEndedByDate;
        }
      }
      approver.taskEndedBy = results.taskEndedBy;
      approver.taskEndedByDate = results.taskEndedByDate;
      return data;
    }
    for (var a = 0, len = data.length; a < len; a++) {
      approver = data[a];
      if (approver.taskEndDate) {
        approverMap[approver.activitiTaskId] = {
          taskEndedBy: approver.person,
          taskEndedByDate: approver.taskEndDate
        };
      }
    }
    for (var b = 0, len = data.length; b < len; b++) {
      approver = data[b];
      results = approverMap[approver.activitiTaskId];
      if (results && !approver.taskEndDate) {
        approver.taskEndedBy = results.taskEndedBy;
        approver.taskEndedByDate = results.taskEndedByDate;
      }
    }
    return data;
  }
  function organizeOrgApprovers(data) {
    var groups = [],
      orgMap = {},
      orgName = null,
      previousTask = null,
      task = null;
    for (var j = 0, len = data.length; j < len; j++) {
      task = data[j];
      if (task.taskEndDate && task.person) {
        task.taskEndedBy = task.person;
      } else {
        task.taskEndedBy = null;
      }
      if (task.person) {
        task.people = [task.person];
        delete task.person;
      }
      if (!task.people) {
        task.people = [];
      }
      if (task.organizationName) {
        orgName = task.organizationName;
        orgMap[orgName] = orgMap[orgName] || {};
        previousTask = orgMap[orgName][task.activitiTaskId];
        if (previousTask) {
          if (task.taskEndDate > previousTask.taskEndDate) {
            for (var prop in task) {
              if (prop == 'people') {
                continue;
              }
              previousTask[prop] = task[prop];
            }
          }
          previousTask.people = previousTask.people.concat(task.people);
        } else {
          orgMap[orgName][task.activitiTaskId] = task;
          groups.push(task);
        }
      }
    }
    return groups;
  }
  ;
  var InvestigatorApprover = BaseModel.extend({
    virtual: {
      'person.displayName': function personDisplayName() {
        if (this.get('person')) {
          return this.get('person').get('displayName');
        } else {
          return '';
        }
      }
    },
    initialize: function initialize() {
      BaseModel.prototype.initialize.apply(this, arguments);
      if (this.get('taskEndedBy')) {
        this.set('taskEndedBy', new PersonModel(this.get('taskEndedBy')));
      }
      this.set('person', new PersonModel(this.get('person')));
    }
  });
  var OrgApprover = BaseModel.extend({
    virtual: {
      'displayName': function displayName() {
        var displayName = '';
        this.get('people').forEach(function (person, index) {
          displayName += (index != 0 ? ', ' : '') + person.get('displayName');
        });
        return displayName;
      }
    },
    initialize: function initialize() {
      BaseModel.prototype.initialize.apply(this, arguments);
      if (this.get('taskEndedBy')) {
        this.set('taskEndedBy', new PersonModel(this.get('taskEndedBy')));
      }
      this.set('people', new Backbone.Collection(this.get('people'), {
        model: PersonModel
      }));
    }
  });
  var SubmissionApprovalsTabContent = Mn.ItemView.extend(UIKit.ComponentMixin).extend({
    useInjector: true,
    template: Templates.IRB['submission.approvals.tab'],
    options: {
      investigatorApprovers: null,
      orgApprovers: null,
      submissionApprovalsHeaderText: langs.phrase('Submissions.Details.Approvals.Title'),
      submissionResearchTeamHeader: langs.phrase('Submissions.Details.Approvals.ResearchTeam.Title'),
      submissionOrgApproversHeader: langs.phrase('Submissions.Details.Approvals.OrgApprovers.Title')
    },
    update: {
      investigatorApprovers: false,
      orgApprovers: false,
      submissionApprovalsHeaderText: false,
      submissionResearchTeamHeader: false,
      submissionOrgApproversHeader: false
    },
    internalViewOptions: {
      investigatorLabel: {
        attributes: {
          id: 'researchTeamHeader'
        }
      },
      investigatorTable: {
        ariaLabelledby: 'researchTeamHeader approvalsHeader'
      },
      orgApproversLabel: {
        attributes: {
          id: 'orgApproversHeader'
        }
      },
      orgApproversTable: {
        ariaLabelledby: 'orgApproversHeader approvalsHeader'
      }
    },
    initialize: function initialize() {
      UIKit.ComponentMixin.initialize.apply(this, arguments);
      this.investigatorApprovers = InvestigatorApprover.createCollection();
      this.orgApprovers = OrgApprover.createCollection();
      this._setupApproverTables();
      this._setupListeners();
    },
    _setupListeners: function _setupListeners() {
      var self = this;
      this.collection.addAdapter({
        filter: function filter(data) {
          self.investigatorApprovers.reset(setupApprovers(data.CERTIFY || []));
          self.orgApprovers.reset(organizeOrgApprovers(data.ORG_APPROVED || []));
          return data;
        }
      });
      this.listenTo(this.orgApprovers, 'reset', function () {
        this.orgApproversTable.visible = !!this.orgApprovers.length;
        this.orgApproversLabel.visible = !!this.orgApprovers.length;
      });
    },
    _setupApproverTables: function _setupApproverTables() {
      this.investigatorTable.columns.add(INVESTIGATOR_APPROVALS_COLUMNS);
      this.investigatorTable.compact = true;
      this.investigatorTable.padded = false;
      this.investigatorTable.sortable = false;
      this.investigatorTable.collection = this.investigatorApprovers;
      this.orgApproversTable.columns.add(ORG_APPROVALS_COLUMNS);
      this.orgApproversTable.compact = true;
      this.orgApproversTable.padded = false;
      this.orgApproversTable.sortable = false;
      this.orgApproversTable.visible = false;
      this.orgApproversTable.collection = this.orgApprovers;
      this.orgApproversLabel.visible = false;
    }
  });
  module.exports = SubmissionApprovalsTabContent;
});

